<script setup>
import { ref, watch } from 'vue';
import ModalSimple from '@/components/ModalSimple.vue';
import BotonGuardar from '@/components/inputs/BotonGuardar.vue';
import InputRadio from '@/components/cifra/InputRadio.vue';

const VALOR_INICIAL_TIPO_BLOQUEO = 'no_recalcular';
const emits = defineEmits(['aceptar']);

const props = defineProps({
  leyEducativa: {
    type: String,
    default: () => 'LOMLOE',
  },
});

const modelValue = defineModel('modelValue', {
  type: Boolean,
  default: false,
});
const ejecutando = defineModel('ejecutando', {
  type: Boolean,
  default: false,
});

const showInterno = ref(modelValue);
const tipoBloqueo = ref(VALOR_INICIAL_TIPO_BLOQUEO);

watch(showInterno, () => {
  // Reseteamos el tipo de bloqueo cada vez que se abre el modal
  tipoBloqueo.value = VALOR_INICIAL_TIPO_BLOQUEO;
});
</script>

<template>
  <ModalSimple v-model="showInterno" :titulo="$t('atencion!')">
    <div>
      <form @submit.prevent="emits('aceptar', tipoBloqueo)" :disabled="ejecutando">
        <p>
          {{ $t('lomloe_notas_bloqueadas_explicacion', { ley: leyEducativa }) }}
        </p>
        <div class="mt-5">
          <InputRadio
            v-model="tipoBloqueo"
            value="no_recalcular"
            name="tipoBloqueo"
          >
            {{ $t('Bloquear_evaluacion_sin_recalcular_notas') }}
          </InputRadio>
        </div>
        <div class="mt-2 mb-5">
          <InputRadio
            v-model="tipoBloqueo"
            value="si_recalcular"
            name="tipoBloqueo"
            class="text-danger"
          >
            {{ $t('Bloquear_evaluacion_recalculando_notas') }}
          </InputRadio>
        </div>
        <div class="form-actions">
          <button class="btn btn-default" @click.prevent="emits('update:modelValue', false)">
            {{ $I18n.t('Cancelar') }}
          </button>
          <BotonGuardar :submitting="ejecutando" :label="$t('Bloquear_evaluacion')" />
        </div>
      </form>
    </div>
  </ModalSimple>
</template>
